import styled from 'styled-components';
import media from '../../../constants/media';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';
import { A, H5 } from '../../base/typography';

export const WrapperLink = styled(A)`
	display: flex;
	flex-direction: column;
	background-color: #fff;
	transition: ease-in-out 0.15s;
	filter: contrast(100%);
	&:hover {
		transition: ease-in-out 0.15s;
		filter: contrast(115%);
		h5 {
			transition: ease-in-out 0.15s;
			color: ${props => props.theme.colors.primaryDark};
		}
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 2.5rem 4rem 2.5rem 0;
	overflow: hidden;

	${media.tablet`
		margin-bottom: 6rem;
	`};

	${media.desktopLarge`
		padding: 2.5rem 4rem 2.5rem 0;
	`};
`;

export const Subtext = styled.span`
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	font-size: 1.6rem;
	line-height: 1.9rem;
	color: ${({ theme }) => theme.colors.secondary};
`;

export const ImageWrapper = styled.div`
	position: relative;
`;

export const Image = styled(DynamicRspImage)`
	padding-bottom: 66%;
	border-radius: 24px;

	${media.tablet`
		padding-bottom: 28rem;
	`};
`;

export const Date = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 1.4rem;
	line-height: 1.6rem;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.grayDate};
`;

export const Title = styled(H5)`
	overflow: hidden;

	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	font-style: normal;
	font-weight: 500;
	font-size: 2rem;
	line-height: 3.5rem;

	color: ${({ theme }) => theme.colors.grayTitle};
	transition: ease-in-out 0.15s;
`;

export const Summary = styled.div`
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-style: normal;
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 2.6rem;
	color: ${({ theme }) => theme.colors.graySummary};
`;

export const ArticleAuthorImage = styled(DynamicRspImage)`
	position: absolute;
	right: 5%;
	bottom: 5%;
	width: 10rem;
	height: 10rem;
	border: 3px solid #fff;
	border-radius: 100%;
`;
